import { Fit, Alignment, Rive, Layout } from 'rive-js';

//

var script = {
    name: "RiveCanvas",
    props: {
        // canvas
        canvasId: {
            type: String,
            required: true,
        },
        canvasWidth: {
            type: Number,
            required: true,
        },
        canvasHeight: {
            type: Number,
            required: true,
        },

        // file
        riveFileSrc: {
            type: String,
            required: true,
        },

        // options
        autoplay: Boolean,

        // layout
        layoutFit: Fit,
        layoutAlignment: Alignment,

        // artboard
        artboard: String,

        // animations
        animations: Array | String,
    },
    emits: ["load", "loaderror", "play", "pause", "loop", "stop"],
    data() {
        return {
            // rive instance
            rive: Object,
        };
    },
    beforeMount() {
        // controller events
        this.$on("play", this.play);
        this.$on("pause", this.pause);
        this.$on("stop", this.stop);
        this.$on("changeArtboard", this.requestArtboardChange);
        this.$on("changeAnimation", this.requestAnimationChange);
    },
    beforeDestroy() {
        // dispose event handlers
        this.$off();
    },
    mounted() {
        const self = this;

        // Rive instantiation
        this.rive = new Rive({
            src: this.riveFileSrc,
            canvas: this.$refs.canvas,
            autoplay: this.autoplay,
            layout: new Layout({
                fit: this.layoutFit,
                alignment: this.layoutAlignment,
            }),
            artboard: this.artboard,
            animations: this.animations,
        });

        // Event wrapping
        this.rive.on("load", (ev) => {
            self.$emit("load", ev, self.rive);
        });

        this.rive.on("loaderror", (ev) => {
            self.$emit("loaderror", ev, self.rive);
        });

        this.rive.on("play", (ev) => {
            self.$emit("play", ev, self.rive);
        });

        this.rive.on("pause", (ev) => {
            self.$emit("pause", ev, self.rive);
        });

        this.rive.on("loop", (ev) => {
            self.$emit("loop", ev, self.rive);
        });

        this.rive.on("stop", (ev) => {
            self.$emit("stop", ev, self.rive);
        });
    },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  const options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  let hook;

  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      const originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      const existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("canvas", {
    ref: "canvas",
    attrs: {
      id: _vm.canvasId,
      width: _vm.canvasWidth,
      height: _vm.canvasHeight
    }
  })
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Import vue component

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('RiveCanvas', __vue_component__);
} // Create module definition for Vue.use()

var plugin = {
  install: install
}; // Auto-install when vue is found (eg. in browser via <script> tag)

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
} // To allow use as module (npm/webpack/etc.) export component

export default __vue_component__;
export { install };
